import React from "react";
import { Modal, Button } from "react-bootstrap";
import {useTranslation} from "react-i18next";


export const DeleteRule = ({ show, rule, onClose, onConfirm }: any) => {
    const {t} = useTranslation();
    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('RuleList.delete_rule')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {t('RuleList.delete_rule_description')}
                <strong> {rule?.name}</strong>?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={onClose}>{t('RuleList.cancel')}</Button>
                <Button variant="primary" onClick={onConfirm}>{t('RuleList.delete')}</Button>
            </Modal.Footer>
        </Modal>
    );
};